import React from "react";

import { templates } from "@reactivated";

import { ShopCompareGrid } from "../apps/shop-compare/ShopCompare";

export const Template = (props: templates.ShopCompareGridTemplate) => {
    if (!props.tileset) {
        return null;
    }
    return (
        <div>
            <ShopCompareGrid value={props} />
        </div>
    );
};
